// import $ from 'jquery';
// window.jQuery = window.$ = $;

require('./polyfills.js');
// require('./../../vendors/slimbox205/src/slimbox2.js');
// require('./../../vendors/slimbox205/src/autoload.js');
// require('./jquery.showMore.js');
// require('./jquery.sideNavigation.js');